import { inject } from '@angular/core';
import { FunctionalCoreService } from 'app/functional-core/functional-core.service';
import { PermissionService } from 'app/identity-and-access/permission.service';
import { Command } from 'app/imperative-shell';

export class SetCustomPriceDate implements Command {
  constructor(private customPriceDate: Date | undefined) {}

  public execute(): Promise<Command[]> {
    const permissions = inject(PermissionService);
    const data = inject(FunctionalCoreService);

    if (permissions.canUseCustomPriceDate) {
      data.ambient.clientSetting.setCustomPriceDate(this.customPriceDate);
    }
    return Promise.resolve([]);
  }
}
